export const getColorByCategory = (category) => {
  let color = "";

  switch (category) {
    case "Stock Analysis":
      color = "#AE21D0";
      break;

    case "Social Media":
      color = "#EC6100";
      break;

    case "Official statements":
      color = "#006FC6";
      break;

    case "Legal documents":
      color = "#9E3C1A";
      break;

    case "Press releases":
      color = "#E72222";
      break;

    case "Reports":
      color = "#4ABB9B";
      break;

    case "Job Postings":
      color = "#CFA700";
      break;

    case "Working papers":
      color = "#54A900";
      break;

    case "Warnings Enforcements Sanctions":
      color = "#334f18";
      break;

    case "Guidelines":
      color = "#75188C";
      break;

    default:
      color = "#AE21D0";
  }
  return color;
};
